import React from 'react';
import { Bell } from 'lucide-react';
import { useGlobalNotifications } from '@/hooks/system/useGlobalNotifications';

interface NotificationBellProps {
  onNotificationClick?: () => void;
  notificationCount?: number;
}

const NotificationBell: React.FC<NotificationBellProps> = ({ onNotificationClick, notificationCount: propNotificationCount }) => {
  // Use the global notifications hook to get connection status and notification count
  const { isConnected, isLoading, notificationCount: hookNotificationCount } = useGlobalNotifications();
  
  // Use prop count if provided, otherwise use the count from the hook
  const notificationCount = propNotificationCount !== undefined ? propNotificationCount : hookNotificationCount;
  
  return (
    <button
      type="button"
      className="relative inline-flex items-center justify-center p-2 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      aria-label="Notifications"
      onClick={onNotificationClick}
      data-testid="notification-bell"
    >
      <Bell className="h-6 w-6 text-gray-700" />
      
      {/* Connection status indicator - touching the bottom-right of the bell icon */}
      <span
        className={`absolute bottom-1 right-1 w-2.5 h-2.5 rounded-full ${
          isLoading ? "bg-yellow-500 animate-pulse" :
          isConnected ? "bg-green-500" :
          "bg-amber-700"
        }`}
        title={
          isLoading ? "Connecting..." :
          isConnected ? "Connected" :
          "Disconnected"
        }
      />
      
      {notificationCount > 0 && (
        <span className="absolute top-0 right-0 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
          {notificationCount}
        </span>
      )}
    </button>
  );
};

export default NotificationBell;
